// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"nF-z","smallCardRow":"oF-z","largeCardRow":"pF-z","productSearchRow":"qF-z","curatedRow":"rF-z"};